/**
 * @generated SignedSource<<6c9181f9709abc30c6d234253ecaaa71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResetSubstitutionsInput = {
  productId: string;
};
export type ResetSubstitutionsMutation$variables = {
  input: ResetSubstitutionsInput;
};
export type ResetSubstitutionsMutation$data = {
  readonly resetSubstitutions: {
    readonly _empty: string | null | undefined;
  } | null | undefined;
};
export type ResetSubstitutionsMutation = {
  response: ResetSubstitutionsMutation$data;
  variables: ResetSubstitutionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ResetSubstitutionsPayload",
    "kind": "LinkedField",
    "name": "resetSubstitutions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_empty",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetSubstitutionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetSubstitutionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3e91b86c1659a812bd7d78cb24971ea0",
    "id": null,
    "metadata": {},
    "name": "ResetSubstitutionsMutation",
    "operationKind": "mutation",
    "text": "mutation ResetSubstitutionsMutation(\n  $input: ResetSubstitutionsInput!\n) {\n  resetSubstitutions(input: $input) {\n    _empty\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1517d76e04be9cd74ee07da6c555e9a";

export default node;
